var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeColor } from '../types';
import { css } from '@emotion/css';
export function PauseIcon() {
    return (_jsx("svg", __assign({ className: iconStyle, version: "1.1", viewBox: "0 0 1200 1200", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsxs("g", __assign({ fillRule: "evenodd", fill: ThemeColor.lightGray }, { children: [_jsx("path", { d: "m733.88 24.086h408.03v1153.2h-408.03z" }), _jsx("path", { d: "m58.086 24.086h408.03v1153.2h-408.03z" })] })) })));
}
var iconStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 30px;\n  margin-left: -1px;\n"], ["\n  height: 30px;\n  margin-left: -1px;\n"])));
var templateObject_1;
//# sourceMappingURL=PauseIcon.js.map